'use strict';

/**
 *
 * @name: equalizeHeight
 *
 */

function EqualizeHeightDirective() {

  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {

      var selector = attrs.equalizeHeight,
        items = element.find(selector);

      if (items.length) {

        var updateLayout = function() {

          var mh = 0;
          items.css('min-height', '').each(function() {
            mh = $(this).height() > mh ? $(this).height() : mh;
          });
          items.css('min-height', mh);
        };

        updateLayout();
        setTimeout(updateLayout, 1);
      }
    }
  };
}

export default EqualizeHeightDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-equalize-height.directive.js